import dayjs from 'dayjs';
import { useMemo, useRef } from 'react';
import { exportChart } from '../../../../helpers/image-downloader/image-downloader';
import { useFinancialsStore } from '../../../../store/financials-store/financials-store';
import { setCostVersusOutputChartType } from '../../../../store/financials-store/financials-store.actions';
import { ChartType } from '../../../../store/financials-store/financials-store.type';
import { useGlobalStore } from '../../../../store/global-store/global-store';
import { useCostVersusOutput } from '../../financials.hooks';
import { ChartDisplayTypeButtonSet } from '../shared/chart-display-type-button-set';
import { Chart as BarChart } from './bar-chart';
import { buildTrendLines, transformCostVersusOutputData } from './cost-versus-output.helpers';
import { Chart as LineChart } from './line-chart';

function Chart() {
  const portfolio = useGlobalStore((state) => state.portfolio);
  const teamId = useFinancialsStore((state) => state.team);
  const boardId = useFinancialsStore((state) => state.board);
  const startDate = useFinancialsStore((state) => state.startDate);
  const endDate = useFinancialsStore((state) => state.endDate);
  const selectedChartType = useFinancialsStore((state) => state.filters.costVersusOutput.selectedChartType);

  const chartRef = useRef<HTMLDivElement>(null);

  const { data } = useCostVersusOutput(
    dayjs(startDate).toDate(),
    dayjs(endDate).toDate(),
    portfolio?.id || null,
    teamId,
    boardId,
  );

  const chartData = transformCostVersusOutputData(data);

  const chartDataWithTrendLines = buildTrendLines(chartData);

  const chart = useMemo(() => {
    if (selectedChartType === ChartType.Line) {
      return <LineChart chartData={chartDataWithTrendLines} chartRef={chartRef} />;
    }
    return <BarChart chartData={chartDataWithTrendLines} chartRef={chartRef} />;
  }, [selectedChartType, chartDataWithTrendLines]);

  return (
    <>
      <ChartDisplayTypeButtonSet
        onSetLineChart={() => setCostVersusOutputChartType(ChartType.Line)}
        onSetBarChart={() => setCostVersusOutputChartType(ChartType.Bar)}
        selectedChartType={selectedChartType}
        onExportChart={() => exportChart(chartRef.current, 'cost-versus-output-chart.png')}
      />
      {chart}
    </>
  );
}

export { Chart };
